<template>
	<div class="pride-place-card-container" >
		<div class="pride-place-card">
			<div>
				<h1 v-html="place.HEADER" :class="place.TXT_COLOR"></h1>
				<h2 v-html="place.LOCATION" :class="place.TXT_COLOR"></h2>
				<p v-html="place.BODY" :class="place.TXT_COLOR"></p>
				<a v-bind:href="place.BTN_LINK">
					<button v-html="place.BTN_COPY" class="pride-btn"></button>
				</a>
			</div>
			<div class="place-image" v-bind:style="{ 'background-image': 'url(' + getImgUrl(place.BG_BUBBLE) + ')' }" ref="placesref">
				<img class="" :src="getImgUrl(place.IMAGE)"  />
			</div>
		</div>
	</div>
</template>

<script>
	// import inViewMixin from "../../../src/mixins/inViewMixin";

	export default {
			name: "pride-place-card",
			// mixins: [inViewMixin],
			props: {
				place: {
						type: Object,
						// default: () => {
						// 	return {
						// 		root: null,
						// 		threshold: "0"
						// 	};
						// }
				},
				index: {
						type: Number
				},
			},
			// data(){
			// 	return{
			// 		observer : null
			// 	}
			// },
			// mounted(){
			// 	this.observer = new IntersectionObserver( entries => {
			// 		this.handleIntersect(entries[0]);
			// 	}, this.options);
			// 	this.observer.observe(this.$refs.placesref);
			// },
			// destroyed(){
			// 	this.observer.disconnect();
			// },
			methods: {
				getImgUrl: place => {
					const images = require.context(
						"./../../assets/pride/places/",
						false
					);
					return  images("./" + place) 
				},
			},
			

	};
</script>
<style lang='scss' scoped>

	.pride-place-card-container {

		.test {
			animation: move 1s forwards;
			animation-delay: 100ms;
		}

		@keyframes move {
			from {
				opacity: 0;
			}

			to {
				opacity: 1;
			}
		}

		@media (max-width: 768px) {
			margin-bottom: 5em;
		}

		@media (min-width: 768px) {
			height: 100vh;
		}

		.pride-place-card {

			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
			flex-direction: column-reverse;

			@media (min-width: 768px) {
				flex-direction: row;
			}

			.place-image {
    		background-size: contain;
				background-repeat: no-repeat;
				background-position: center center;
				height: 82vw;
				display: flex;
				justify-content: center;
				align-items: center;

				@media (max-width: 768px) {
					padding: 4em 0;
				}

				@media (min-width: 768px) {
					height: 100%;
				}

				img {
					width: 80%;
					@media (min-width: 768px) {
						width: 60%;
					}
				}

			}

			div {
				flex-direction: column;

				@media (min-width: 768px) {

					h1, h2, p {
						text-align: left;
					}

				}

				@media (min-width: 768px) {
					flex: 0 1 50%
				}

			}

		}

		@media (min-width: 768px) {

			&:nth-of-type(odd) {
				.pride-place-card {
					flex-direction: row-reverse;
					div {
						&:first-of-type {
							padding-left: 50px;
							text-align: left;
						}
					}
				}
			}

			&:nth-of-type(even) {
				.pride-place-card {
					div {
						&:first-of-type {
							text-align: left;
						}
					}
				}
			}

		}

		.purple-txt {
			color: #3f2c82;
		}

		.white-txt {
			color:	#ffffff ;
		}

	}

</style>


// WEBPACK FOOTER //
// src/components/pride/PridePlaceCard.vue